import router from './router'
import { getToken, getAccountId } from '@/utils/auth'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

router.beforeEach(async (to, from, next) => {
    NProgress.start()
    const hasToken = getToken()
    const hasAccountToken = getAccountId()
    if (to.name == 'launchLogin' || to.name == 'launch' || to.name == 'infor' || to.name == 'watchLogin' || to.name == 'watch') {
        next()
    } else {
        if (hasToken) {
            if (to.name == 'login') {
                next({ path: '/' })
            } else {
                next()
            }
        } else {
            if (to.name == 'login') {
                next()
            } else {
                next({ path: '/login' })
            }
        }
    }
    NProgress.done()
})
